import React from "react";

const CheckedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <defs>
        <clipPath id="clipPath3965114659">
          <path
            d="M0 0L30 0L30 30L0 30L0 0Z"
            fillRule="nonzero"
            transform="matrix(1 0 0 1 0 0)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clipPath3965114659)">
        <path
          d="M19.7088 -0.705409C19.3192 -1.09687 18.686 -1.09838 18.2946 -0.7088L5.9375 11.5892L0.70541 6.3821C0.313953 5.99252 -0.319216 5.99403 -0.7088 6.38549C-1.09838 6.77695 -1.09687 7.41012 -0.70541 7.7997L5.23209 13.7088Q5.30169 13.7781 5.38343 13.8325Q5.46517 13.8869 5.55592 13.9243Q5.64668 13.9618 5.743 13.9809Q5.83931 14 5.9375 14Q6.03569 14 6.132 13.9809Q6.22832 13.9618 6.31908 13.9243Q6.40983 13.8869 6.49157 13.8325Q6.57331 13.7781 6.64291 13.7088L19.7054 0.7088C20.0969 0.319217 20.0984 -0.313953 19.7088 -0.705409Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 5 8)"
          fill="rgb(0, 0, 0)"
        />
      </g>
    </svg>
  );
};

export default CheckedIcon;
